<template>
    <span :class="{
        badge: true,
        [`badge-${status_class}`]: true
    }">{{status_text}}</span>
</template>

<script>
    export default {
        name: "RequestCallStatusBadge",
        props: ['call'],
        data: () => ({
            dictionary_slug: {
                NEW: '...',
                ANSWERED: 'Ответил',
                NO_ANSWER: 'Не отвечает',
                BUSY: 'Занято',
            },
        }),
        computed: {
            status_text: function () {
                if (this.call.direction === 'IN' && this.call.status === 'NO_ANSWER') return 'Пропущенный';
                return this.dictionary_slug[this.call.status];
            },
            status_class: function () {
                if (this.call.direction === 'IN' && this.call.status === 'NO_ANSWER') return 'danger';
                switch (this.call.status) {
                    case 'NEW':
                        return 'info';
                    case 'ANSWERED':
                        return 'success';
                    case 'NO_ANSWER':
                        return 'warning';
                    case 'BUSY':
                        return 'warning';
                }
                return '';
            }
        },
    }
</script>

<style scoped>

</style>
